import React from 'react';
import { HStack, IconButton, Tooltip } from '@chakra-ui/react';
import Icons from '@/components/icons/Icons';
import { Comment } from '@/wpt-lib/interfaces/Comment';

interface SingleCommentOptionsProps<T> {
    comment: T;
    onDelete?: (comment: T) => void;
    onEdit?: (comment: T) => void;
}

export const SingleCommentOptions = <T extends Comment>({
    comment,
    onDelete,
    onEdit,
}: SingleCommentOptionsProps<T>) => {
    return (
        // wrap menu in Box to prevent popper.js issue
        // https://github.com/chakra-ui/chakra-ui/issues/3173#issuecomment-981403435
        <HStack justifyContent="flex-start">
            {onEdit && (
                <Tooltip label="Edit comment">
                    <IconButton
                        onClick={() => onEdit(comment)}
                        aria-label={'Edit comment: ' + comment}
                        icon={<Icons.EditIcon />}
                        size="md"
                        m={0}
                    />
                </Tooltip>
            )}
            {onDelete && (
                <Tooltip label="Delete comment">
                    <IconButton
                        onClick={() => onDelete(comment)}
                        aria-label={'Delete comment: ' + comment}
                        icon={<Icons.DeleteIcon />}
                        size="md"
                        m={0}
                    />
                </Tooltip>
            )}
        </HStack>
    );
};
